// Entidades del entorno
export const ENTITY_USUARIO = 'usuario';
export const ENTITY_CONTACTO = 'contacto';
export const ENTITY_CLIENTE = 'cliente';
export const ENTITY_SUBCUENTA = 'subcuenta';
export const ENTITY_FACTURAS = 'Facturas';
export const PROVEEDORES = 'Proveedores';
export const BANCOS = 'Bancos';
export const VENCIMIENTOS = 'Vencimientos';
export const DIARIO = 'Diario';
export const MOVIMIENTOS_TESORERIA = 'MovimientosTesoreria';

export const FORMASPAGO = 'FormasPago';
export const PARTIDAS_PRESUPUESTO = 'PartidasPresupuesto';
export const PRESUPUESTO_CONTABLE = 'PresupuestoContable';
export const GASTOS = 'Gastos';

export const TAREAS = 'Tareas';
export const IMPUESTO_347_PROVEEDORES = 'Impuesto347Proveedores';
export const IMPUESTO_347_CLIENTES = 'Impuesto347Clientes';
